module.exports = __webpack_public_path__ + "img/image 10.3ba8ba25.png";